// export const MAIN_URL = 'https://milaniautoclinic.ir/api/v1/'
// export const MAIN_URL_IMAGE = 'https://milaniautoclinic.ir/'
// export const SITE_ADDRESS = 'https://milaniautoclinic.ir'

export const MAIN_URL = '/api/v1/'
export const MAIN_URL_IMAGE = ''
export const SITE_ADDRESS = 'https://milaniautoclinic.ir'
